//@ts-check
import React, { useState, useEffect } from "react"
import { makeStyles } from "@material-ui/core/styles"
import CircularProgress from "@material-ui/core/CircularProgress"
import { useTranslation } from "react-i18next"
import AddressDisplay from "./address-display"
import CONSTS from "shared/consts"
import Tooltip from "./tooltip"
import ParameterDisplay from "./parameter-display"
import { Chip } from "@material-ui/core"
import store from "../store"
import web3 from "../utils/web3"
import { StepResultTable } from "./step-result-table"
import { useStepIndex } from "./step-index-context"
const styles = makeStyles(() => ({
  resultContainer: {
    display: "grid",
    alignItems:"baseline",
    gridTemplateColumns: "110px 50%",
    margin:5,
    alignItems:'start',
  },
  resultTitle: {
    // padding: "5px",
    fontSize: "0.875rem",
    fontFamily: "EYInterstate light"
  },
  resultValue: {
    fontSize: "0.875rem",
  }
}))

/**
 * This function handles the display of log
 * parameters types, names and values.
 * @param {Object} log - A log object recieved from VM.
 */
function mapLogParams(log) {
  const { parameters, parameterTypes } = log
  return parameterTypes?.map((param, index,list) => {
    return (
      <span
        style={{
          color: "#747480",
          whiteSpace:'nowrap',
          fontSize: 14,
        }}
      >
        {param.name}=
        <b style={{ color: "#000" }}>
        {
          (param.type=="address" ||
          param.type!="address" && String(parameters).length>10)
            && 
          <AddressDisplay address={parameters[index]} />
        }
        {
          (param.type!="address" &&
            String(parameters).length<=10)
            && 
          parameters[index]
        }
        </b>
      </span>
    )
  })
}

export default function StepResults() {
  // States:
  const { t } = useTranslation()
  var [showTestOutput, setShowTestOutput] = useState(false)
  
  store.useRerenderIfChange(()=>[store.currentResult, store.results[0]?.steps_output?.length])
  
  const classes = styles({})
  var steps=store.steps
  var stepIndex=useStepIndex()
  var step = steps[stepIndex]
  var stepResults = store.results?.[store.currentResult]?.steps_output?.find(x=>x.uid==step.uid)
  var blockNumber = store.results?.[store.currentResult]?.steps_output?.[stepIndex]?.blockNumber
  
  if (!stepResults) return <div></div>
  if (!stepResults) return <div>No results for this step.</div>
  
  
  if (!stepResults) return null
  
  var td=StepResultTable({
    blockNumber,
    step,
    store,
    textOnly:false
  })
  return (
    <>
      <div css={`background:white;margin:10px;padding:10px;`}>
        {td.map((field) => (
          <div key={JSON.stringify(field)} className={classes.resultContainer}>
            <div className={classes.resultTitle}><Tooltip tip={field.tip}>{field.title}</Tooltip>:</div>
            <div className={classes.resultValue}>
              {field.value(
                step,
                stepResults,
              )}
            </div>
          </div>
        ))}        
      </div>
    </>
  )
}

function formatNumberCommas(s) {
  s = String(s)
  var n = ""
  for (var i = 0; i < s.length; i++) {
    n = s[s.length - 1 - i] + n
    if ((i + 1) % 3 == 0 && i < s.length - 1) n = "," + n
  }
  return n
}
